export default "/images/e6f6e177f82b1e01b0386ba510ea2905.avif";